// @flow

import Game from '@/lib/game';

export default class {
  static isSatisfied(game: Game): boolean {
    const { cedarAdultTreesCount } = game.stats;
    return cedarAdultTreesCount >= 7 && game.virtualTime.season === 'spring';
  }

  static makeAchievement() {
    return {
      uid: 'cedar_forest',
      title: '花粉王国',
      body: '杉の木がたくさん生えて人々が花粉症に苦しみ始めました。',
    };
  }
}



// WEBPACK FOOTER //
// ./src/lib/achievement_conditions/cedar_forest.js